export default "__VITE_ASSET__IEnjMu3i__"